<template>
  <original-button
    :icon="icon ? `ti-${icon}` : ''"
    v-bind="$attrs"
    v-on="allListeners"
  >
    <slot></slot>
  </original-button>
</template>

<script>
import { Button } from 'element-ui'

/**
 * Bouton qui permet de gérer un lien du routeur.
 *
 * Basé principalement sur le [bouton Element](https://element.eleme.io/#/fr-FR/component/button)
 * @link https://element.eleme.io/#/fr-FR/component/button
 */
export default {
  name: 'ElButton',
  props: {
    /**
     * Lien vers lequel rediriger au clic, remplace l'évènement `click` du bouton d'origine
     */
    to: [String, Object],
    /**
     * Icône Themify
     */
    icon: String
  },
  components: {
    OriginalButton: Button
  },
  computed: {
    allListeners () {
      return this.to
        ? { click: this.goTo, ...this.$listeners }
        : this.$listeners
    }
  },
  methods: {
    goTo () {
      if (!this.to) return
      this.$router.push(this.to)
    }
  }
}
</script>

<docs>
### Exemples

```jsx
<el-button to="#">Lien ancré</el-button>
<el-button to="{name: 'dashboard'}" type="danger">Lien vers tableau de bord</el-button>
```
</docs>
